import { Box, Container, Image, Text, Heading } from '@redriverpress/system'

import getInitialState from 'Common/utils/getInitialState'
import { renderInlineMarkdown } from 'Common/utils/markdown'

import CollectionLink from '../CollectionLink'

export default function CategoryCollections() {
  const { collections, brandable, slug: categorySlug } = getInitialState()

  return (
    <Box bg='gray100'>
      <Container pt={4} pb={[4, null, 5]}>
        <Box
          display='grid'
          gridTemplateColumns={['1fr', null, '1fr 1fr', '1fr 1fr 1fr']}
          gridGap='1rem'
        >
          {collections.map(collection => (
            <Box key={collection.slug} bg='white' borderRadius='rounded'>
              <CollectionLink
                href={`/collections/${categorySlug}/${collection.slug}`}
              >
                {brandable && (
                  <Image
                    src={collection.thumbnail}
                    alt=''
                    width='100%'
                    height='auto'
                    mb={4}
                    borderRadius='rounded'
                  />
                )}
                <Heading
                  as={brandable ? 'h5' : 'h4'}
                  mb={collection.description ? 3 : 0}
                >
                  {collection.title}
                </Heading>
                {collection.description && (
                  <Text
                    dangerouslySetInnerHTML={{
                      __html: renderInlineMarkdown(
                        collection.description || ''
                      ),
                    }}
                  />
                )}
              </CollectionLink>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  )
}
